// src/components/Header.jsx

import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import Drawer from './Drawer';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <>
      <header className="flex justify-between items-center px-4 py-3 bg-blue-800 text-white">
        <h1 className="text-lg font-bold">
          <Link to="/detail" className="hover:text-blue-900">
            パチンコ回転率チェッカー
          </Link>
        </h1>
        <button onClick={toggleDrawer}>
          <Menu className="w-6 h-6" />
        </button>
      </header>

      <Drawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
    </>
  );
};

export default Header;
